<template>
    <div v-if="!item.hidden">
        <!-- 渲染普通菜单 -->
        <el-menu-item
            v-if="
                !item.children ||
                !(item.children.length > 0) ||
                item.meta.hiddenChild
            "
            class="hvr-bounce-to-bottom"
            :index="resolvePath(item.path)"
            :style="imgMenu ? { padding: '0 14px' } : {}"
        >
          <template v-if="!imgMenu">
            <div class="menu-item-content">
              <p class="menu-item-title">{{ item.meta.title }}</p>
              <p class="menu-item-sub-title" v-if="item.meta.subTitle">{{ item.meta.subTitle }}</p>
            </div>
          </template>
          <el-image
              v-else-if="imgMenu && imgSrc"
              class="img_menu_item"
              :src="imgSrc"
          ></el-image>
        </el-menu-item>
        <el-submenu
            v-else
            class="hvr-bounce-to-bottom"
            ref="subMenu"
            popper-append-to-body
            popper-class="submenu-popper"
            :index="item.children[0].path"
            @open="handleSubMenuOpen"
            @close="handleSubMenuClose"
            @mouseenter.native="handleSubMenuEnter"
            @mouseleave.native="handleSubMenuLeave"
        >
            <template slot="title">
              <template v-if="!imgMenu">
                <div class="menu-item-content" v-if="!imgMenu">
                  <p class="menu-item-title">{{ item.meta.title }}</p>
                  <p class="menu-item-sub-title" v-if="item.meta.subTitle">{{ item.meta.subTitle }}</p>
                </div>
                <div class="menu-arrow-icon">
                  <i class="el-icon-caret-bottom"></i>
                </div>
              </template>
            </template>
            <template>
                <el-menu-item
                    class="el-menu-item"
                    v-for="submenu in item.children"
                    :key="submenu.path"
                    :index="resolvePath(submenu.path)"
                >
                    <div class="submenu-item-wrapper">
                        <span class="submenu-item-title">{{ submenu.meta.title }}</span>
                        <span class="submenu-item-tag" v-if="submenu.meta.subTitle">
                            {{ submenu.meta.subTitle }}
                        </span>
                    </div>
                </el-menu-item>
            </template>
        </el-submenu>
    </div>
</template>

<script>
import path from "path";
import AppLink from "./Link";

export default {
    name: "MeanuItem",
    components: { AppLink },
    props: {
        // route object
        item: {
            type: Object,
            required: true,
        },
        isNest: {
            type: Boolean,
            default: false,
        },
        basePath: {
            type: String,
            default: "",
        },
        imgMenu: {
            type: Boolean,
            default: false,
        },
        imgSrc: {
            type: String,
        },
    },
    data() {
        return {
            isOpened: false,
            isHovered: false,
            popperTimer: null,
        };
    },
    mounted() {
        // 监听popper的鼠标事件
        this.$nextTick(() => {
            this.attachPopperListeners();
        });
    },
    beforeDestroy() {
        this.removePopperListeners();
        if (this.popperTimer) {
            clearTimeout(this.popperTimer);
        }
    },
    watch: {
        isOpened(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.attachPopperListeners();
                });
            } else {
                this.removePopperListeners();
            }
        },
        isHovered(newVal) {
            // 通过data属性（而非class）来控制样式
            if (this.$refs.subMenu && this.$refs.subMenu.$el) {
                if (newVal) {
                    this.$refs.subMenu.$el.setAttribute('data-hovered', 'true');
                } else {
                    this.$refs.subMenu.$el.removeAttribute('data-hovered');
                }
            }
        },
    },
    methods: {
        resolvePath(routePath) {
            return path.resolve(routePath);
        },
        handleSubMenuOpen() {
            this.isOpened = true;
        },
        handleSubMenuClose() {
            this.isOpened = false;
            // 关闭时，如果鼠标不在submenu或popper上，清除悬浮状态
            // 延迟清除，给鼠标移动到其他元素的时间
            this.popperTimer = setTimeout(() => {
                // 再次确认popper已关闭且鼠标不在上方
                if (!this.isOpened) {
                    this.isHovered = false;
                }
            }, 150);
        },
        handleSubMenuEnter() {
            this.isHovered = true;
            if (this.popperTimer) {
                clearTimeout(this.popperTimer);
                this.popperTimer = null;
            }
        },
        handleSubMenuLeave() {
            // 延迟处理，如果鼠标移动到popper上，会被取消
            // 清除之前的定时器
            if (this.popperTimer) {
                clearTimeout(this.popperTimer);
            }
            this.popperTimer = setTimeout(() => {
                // 只有在popper没有打开时才清除悬浮状态
                // 如果popper打开，说明鼠标可能移动到popper上了
                if (!this.isOpened) {
                    this.isHovered = false;
                }
            }, 150);
        },
        attachPopperListeners() {
            if (this.$refs.subMenu) {
                // 使用更精确的选择器，避免影响其他submenu的popper
                const popperEl = this.findPopperElement();
                if (popperEl) {
                    popperEl.addEventListener('mouseenter', this.handlePopperEnter);
                    popperEl.addEventListener('mouseleave', this.handlePopperLeave);
                }
            }
        },
        removePopperListeners() {
            const popperEl = this.findPopperElement();
            if (popperEl) {
                popperEl.removeEventListener('mouseenter', this.handlePopperEnter);
                popperEl.removeEventListener('mouseleave', this.handlePopperLeave);
            }
        },
        findPopperElement() {
            // 查找与当前submenu关联的popper元素
            if (!this.$refs.subMenu) return null;
            
            // Element UI的submenu组件会在打开时将popper追加到body
            // 我们可以通过检查popper的可见性和位置来匹配
            const poppers = document.querySelectorAll('.submenu-popper');
            
            // 如果只有一个可见的popper，直接返回它
            const visiblePoppers = Array.from(poppers).filter(
                popper => popper.offsetParent !== null && 
                          window.getComputedStyle(popper).display !== 'none'
            );
            
            // 如果当前submenu是打开的，应该能找到对应的popper
            if (this.isOpened && visiblePoppers.length > 0) {
                // 找到最靠近submenu的popper（通常是最近打开的那个）
                return visiblePoppers[visiblePoppers.length - 1];
            }
            
            return null;
        },
        handlePopperEnter() {
            // 鼠标进入popper时，保持悬浮状态
            this.isHovered = true;
            if (this.popperTimer) {
                clearTimeout(this.popperTimer);
                this.popperTimer = null;
            }
        },
        handlePopperLeave() {
            // 鼠标离开popper时，延迟清除状态
            // 清除之前的定时器
            if (this.popperTimer) {
                clearTimeout(this.popperTimer);
            }
            this.popperTimer = setTimeout(() => {
                // 只有当popper关闭时才清除悬浮状态
                // 如果鼠标移回submenu，handleSubMenuEnter会取消这个定时器
                if (!this.isOpened) {
                    this.isHovered = false;
                }
            }, 150);
        },
    },
};
</script>
<style lang="stylus" scoped>

/deep/ .el-submenu .el-submenu__title .el-submenu__icon-arrow{
  display:none;
}

.el-menu {
    &.page_header_menu{
      border-bottom: none;
      .menu_item_wrapper_sh_manifest .el-menu-item{
        color: #FF551F;
      }
      .menu_item_wrapper_toker .el-menu-item{
        color: #FF551F;
        .menu-item-title{
          
        }
      }
      .el-menu-item,.el-submenu{
        height: 45px;
        line-height: 45px;
        padding: 0 20px 0 16px;
        position: relative;
        transition: all 0.3s ease;

        /deep/ .el-submenu__title{
          height: 100%;
          padding: 0;
          background-color: transparent !important;
        }
      
        .menu-item-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;
          min-width: 80px;
          
          .menu-item-title {
            margin: 0;
            font-size: 15px;
            font-weight: 600;
            color: #333333;
            line-height: 1.2;
            transition: color 0.3s ease;
            white-space: nowrap;
          }
          
          .menu-item-sub-title {
            margin: 0;
            font-size: 12px;
            color: #666666;
            line-height: 1.2;
            margin-top: 2px;
            transition: color 0.3s ease;
            white-space: nowrap;
            opacity: 0.8;
          }
        }
        
        &:hover {
          .menu-item-content {
            .menu-item-title {
              color: #409eff;
            }
            .menu-item-sub-title {
              color: #409eff;
              opacity: 1;
            }
          }
        }
        
        &.is-active {
          .menu-item-content {
            .menu-item-title {
              color: #409eff;
              font-weight: 700;
            }
            .menu-item-sub-title {
              color: #409eff;
              opacity: 1;
            }
          }
        }
      }

      .img_menu_item{
        min-width: 50px;
      }
      .hvr-bounce-to-bottom {
        display: inline-block;
        vertical-align: middle;
        -webkit-transform: perspective(1px) translateZ(0);
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);
        position: relative;
        border-radius: 6px;
        overflow: hidden;
        color: #333333;
        border: none;
        font-size: 15px;
        font-weight: bold;
        margin: 0;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        
        &.is-active{
          border-radius: 4px 4px 0 0;
          border-bottom: 2px solid #409eff;
        }
      }
      .hvr-bounce-to-bottom:before {
        content: "";
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgb(193,194,197);
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: 50% 0;
        transform-origin: 50% 0;
        -webkit-transition-property: transform;
        transition-property: transform;
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -webkit-transition-timing-function: ease-out;
        transition-timing-function: ease-out;
      }
      .hvr-bounce-to-bottom:hover, .hvr-bounce-to-bottom:focus, .hvr-bounce-to-bottom:active {
        color: #333333;
      }
      .hvr-bounce-to-bottom:hover:before, .hvr-bounce-to-bottom:focus:before, .hvr-bounce-to-bottom:active:before {
        -webkit-transform: scaleY(1);
        transform: scaleY(1);
        -webkit-transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
        transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
      }

        /deep/ .hvr-bounce-to-bottom .el-submenu__title{
           color: #333333;
           font-size: 16px;
           font-weight: 600;
           padding: 0 20px;
           height: 60px;
           line-height: 60px;
           transition: all 0.3s ease;
        
        &:hover {
          color: #409eff;
        }
      }
      
      /deep/ .el-submenu .el-menu-item {
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        font-size: 14px;
        color: #666666;
        transition: all 0.3s ease;
        
        &:hover {
          color: #409eff;
          background: rgba(64, 158, 255, 0.05);
        }
        
        &.is-active {
          color: #409eff;
          background: rgba(64, 158, 255, 0.1);
          font-weight: 600;
        }
      }

      .el-menu--horizontal {
        border-bottom: 0px;
      }

      .analysis-menu-color{
        color:#3564dd;
        font-weight:1200 !important;
      }
    }
    .el-submenu{
      &.is-active{
        .menu-arrow-icon{
          i{
            color: #409eff;
          }
        }
      }
      // 鼠标悬浮时旋转箭头
      &:hover{
        .menu-arrow-icon{
          i{
            color: #409eff;
          }
          transform: translateY(-50%) rotate(180deg);
        }
      }
      // 当submenu打开时（Element UI自动添加is-opened类），旋转箭头
      &.is-opened{
        .menu-arrow-icon{
          transform: translateY(-50%) rotate(180deg);
        }
      }
      // 当鼠标在submenu或popper上时（通过data属性控制），保持箭头旋转
      &[data-hovered="true"]{
        .menu-arrow-icon{
          transform: translateY(-50%) rotate(180deg);
        }
      }
    }
    .menu-arrow-icon{
      width: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 100%;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: transform 0.3s ease;
      i {
        font-size: 13px;
        width: 100%;
        text-align: center;
        margin: 0;
        color: #333333;
        transition: color 0.3s ease, transform 0.3s ease;
      }
    }
  }
</style>
